import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';
import { DemGlReconPerspective } from './entities/glRecon/DemReconPerspective';

const demGpRoutes = [
  <Route path="gp/gl-recon" element={<EntityView perspectiveComponent={DemGlReconPerspective} />} />,
]

export default demGpRoutes;